import { render, staticRenderFns } from "./dangerousGoodProofStatus.vue?vue&type=template&id=0b6255f5&scoped=true"
import script from "./dangerousGoodProofStatus.vue?vue&type=script&lang=js"
export * from "./dangerousGoodProofStatus.vue?vue&type=script&lang=js"
import style0 from "./dangerousGoodProofStatus.vue?vue&type=style&index=0&id=0b6255f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6255f5",
  null
  
)

export default component.exports